import { useEffect, useRef } from 'react'
import { useSetState } from 'ahooks'
import { SListTabs } from 'shj-components'

import {
  getPriceBoostRatePage,
  getPriceGrossRatePage,
  getPriceProManagerRatePage,
  getPriceStandardRatePage,
  getProductEnums,
  priceBoostRateBatchDelete,
  priceBoostRateDelete,
  priceBoostRateImport,
  priceBoostRateSave,
  priceBoostRateUpdateById,
  priceGrossRateBatchDelete,
  priceGrossRateDelete,
  priceGrossRateImport,
  priceGrossRateSave,
  priceGrossRateUpdateById,
  priceProManagerRateBatchDelete,
  priceProManagerRateDelete,
  priceProManagerRateImport,
  priceProManagerRateSave,
  priceProManagerRateUpdateById,
  priceStandardRateBatchDelete,
  priceStandardRateDelete,
  priceStandardRateImport,
  priceStandardRateSave,
  priceStandardRateUpdateById,
} from '@/services/product.ts'
import PriceStrategyTable from '@/pages/baseProduct/priceStrategy/list.tsx'
import UrlConfig from '@/api/UrlConfigs.ts'
import MoneySearch from '@/pages/baseProduct/priceStrategy/MoneySearch.tsx'
import { getAuth } from 'shj-utils'

const CategoryList = () => {
  const listRef = useRef()
  const auths = getAuth() || {}

  const apiUrlObj = {
    boost: {
      // 提点率
      getPage: getPriceBoostRatePage,
      add: priceBoostRateSave,
      updateById: priceBoostRateUpdateById,
      deleteById: priceBoostRateDelete,
      batchDelete: priceBoostRateBatchDelete,
      importFile: priceBoostRateImport,
      download: UrlConfig.PlusProductWeb.PriceBoostRateDownload,
      auth: 'boostAuthKey',
    },
    promng: {
      // 项目经理利率
      getPage: getPriceProManagerRatePage,
      add: priceProManagerRateSave,
      updateById: priceProManagerRateUpdateById,
      deleteById: priceProManagerRateDelete,
      batchDelete: priceProManagerRateBatchDelete,
      importFile: priceProManagerRateImport,
      download: UrlConfig.PlusProductWeb.PriceProManagerRateDownload,
      auth: 'promngAuthKey',
    },
    gross: {
      // 毛利
      getPage: getPriceGrossRatePage,
      add: priceGrossRateSave,
      updateById: priceGrossRateUpdateById,
      deleteById: priceGrossRateDelete,
      batchDelete: priceGrossRateBatchDelete,
      importFile: priceGrossRateImport,
      download: UrlConfig.PlusProductWeb.PriceGrossRateDownload,
      auth: 'grossAuthKey',
    },
    STANDARD: {
      // 标配 通项
      getPage: getPriceStandardRatePage,
      add: priceStandardRateSave,
      updateById: priceStandardRateUpdateById,
      deleteById: priceStandardRateDelete,
      batchDelete: priceStandardRateBatchDelete,
      importFile: priceStandardRateImport,
      download: UrlConfig.PlusProductWeb.PriceStandardRateDownload,
      searchKey: 'sourceType',
      auth: 'generalPriceAuthKey',
    },
  }

  const [state, setState] = useSetState<any>({
    activeKey: '',
    tabs: [],
  })

  useEffect(() => {
    getTabs()
  }, [])

  useEffect(() => {
    listRef.current?.reload()
  }, [state.activeKey])

  const getTabs = async () => {
    const tabList = await getProductEnums('com.shj.saas.plus.product.enums.PriceMngTypeEnum')
    let tabs = [
      ...tabList,
      { key: 'STANDARD', description: '价格导入', auth: 'priceImportAuthKey' },
      { key: 'GENERAL', description: '通项价格', auth: 'generalPriceAuthKey' },
    ]
      .map(item => {
        return {
          key: item.key,
          label: item.description,
          auth: item.auth || apiUrlObj[item.key]?.auth,
          children: (
            <PriceStrategyTable
              key={item.key}
              sourceType={item.key}
              apiUrlObj={apiUrlObj[item.key === 'GENERAL' ? 'STANDARD' : item.key]}
              current={item}
            />
          ),
        }
      })
      .concat([
        { key: 'Money', label: '价格查询', auth: 'priceSearchAuthKey', children: <MoneySearch /> },
      ])
    tabs = tabs.filter(item => {
      return auths[item.auth]
    })
    setState({ tabs, activeKey: tabs[0]?.key })
  }

  return (
    <div>
      <SListTabs
        // auth={{
        //   test: false,
        // }}
        items={state.tabs}
        activeKey={state.activeKey}
        onChange={(key: string) => setState({ activeKey: key })}
        hideExtra={false}
      />
    </div>
  )
}

export default CategoryList
